import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// PAYROLL REPORT RELATED APIs
// (Staff and Labour Payroll/Salary Reports)
// ==============================================

// 1. Get All Employee Categories
export const getAllEmpCategories = async () => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetAllEmpCategories`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get PayRoll Cost Centres by Category
export const getPayRollCCbyCategory = async (categoryId) => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetPayRollCCbyCategory?CategoryId=${categoryId || 0}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Get PayRoll Groups
export const getPayRollGroups = async (params) => {
    try {
        const { category, ccCode, labourType, contractor, empType } = params;
         // DEBUG
        
        const queryParams = new URLSearchParams({
            Category: category || '',
            CCCode: ccCode || '',
            LabourType: labourType || '',
            Contractor: contractor || '',
            EmpType: empType || ''
        });
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetPayRollGroups?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 4. Get PayRoll Employees
export const getPayRollEmployees = async (params) => {
    try {
        const { category, ccCode, groupId, labourType, contractor, empType } = params;
         // DEBUG
        
        const queryParams = new URLSearchParams({
            Category: category || '',
            CCCode: ccCode || '',
            GroupId: groupId || '',
            LabourType: labourType || '',
            Contractor: contractor || '',
            EmpType: empType || ''
        });
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetPayRollEmployees?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 5. Get Salary Contractors
export const getSalaryContractors = async () => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetSalaryContractors`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 6. Get Employee Salary Months
export const getEmployeeSalaryMonths = async (reportData) => {
    try {
         // DEBUG
        
        const payload = {
            EmpCategory: reportData.EmpCategory || 
                        reportData.empCategory || 
                        "",
            CCCode: reportData.CCCode || 
                   reportData.ccCode || 
                   "",
            GroupId: reportData.GroupId || 
                    reportData.groupId || 
                    "",
            EmpRefNo: reportData.EmpRefNo || 
                     reportData.empRefNo || 
                     "",
            Year: reportData.Year || 
                 reportData.year || 
                 "",
            FromMonth: reportData.FromMonth || 
                      reportData.fromMonth || 
                      "",
            LabourType: reportData.LabourType || 
                       reportData.labourType || 
                       "",
            ContractorCode: reportData.ContractorCode || 
                          reportData.contractorCode || 
                          "",
            EmployeeType: reportData.EmployeeType || 
                         reportData.employeeType || 
                         ""
        };
        
         // DEBUG
        
        const response = await axios.post(
            `${API_BASE_URL}/HR/GetEmployeeSalaryMonths`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 7. Get Employee Salary Years by Month
export const getEmpSalaryYearsByMonth = async (reportData) => {
    try {
         // DEBUG
        
        const payload = {
            EmpCategory: reportData.EmpCategory || 
                        reportData.empCategory || 
                        "",
            CCCode: reportData.CCCode || 
                   reportData.ccCode || 
                   "",
            GroupId: reportData.GroupId || 
                    reportData.groupId || 
                    "",
            EmpRefNo: reportData.EmpRefNo || 
                     reportData.empRefNo || 
                     "",
            Month: reportData.Month || 
                  reportData.month || 
                  "",
            LabourType: reportData.LabourType || 
                       reportData.labourType || 
                       "",
            ContractorCode: reportData.ContractorCode || 
                          reportData.contractorCode || 
                          "NA",
            EmployeeType: reportData.EmployeeType || 
                         reportData.employeeType || 
                         ""
        };
        
         // DEBUG
        
        const response = await axios.post(
            `${API_BASE_URL}/HR/GetEmpSalaryYearsByMonth`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 8. Get Labour Cost Centre for Salary Report
export const getLabourCCForSalaryReport = async (params) => {
    try {
        const { labourType, contractor } = params;
         // DEBUG
        
        const queryParams = new URLSearchParams({
            LabourType: labourType || '',
            Contractor: contractor || ''
        });
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetLabourCCForSalaryReport?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 9. Get Months Salary Report (Staff - Normal data)
export const getMonthsSalaryForReport = async (reportData) => {
    try {
         // DEBUG
        
        const payload = {
            EmpCategory: reportData.EmpCategory || 
                        reportData.empCategory || 
                        "",
            CCCode: reportData.CCCode || 
                   reportData.ccCode || 
                   "",
            EmpRefNo: reportData.EmpRefNo || 
                     reportData.empRefNo || 
                     "",
            GroupId: reportData.GroupId || 
                    reportData.groupId || 
                    "",
            Year: reportData.Year || 
                 reportData.year || 
                 "",
            FromMonth: reportData.FromMonth || 
                      reportData.fromMonth || 
                      "",
            ToMonth: reportData.ToMonth || 
                    reportData.toMonth || 
                    ""
        };
        
         // DEBUG
        
        const response = await axios.post(
            `${API_BASE_URL}/HR/GetMonthsSalaryForReport`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 10. Get Single Employee Salary Data for Report (Staff - Details view)
export const getSingleEmpSalaryDataForReport = async (reportData) => {
    try {
         // DEBUG
        
        const payload = {
            EmpCategory: reportData.EmpCategory || 
                        reportData.empCategory || 
                        "",
            CCCode: reportData.CCCode || 
                   reportData.ccCode || 
                   "",
            GroupId: reportData.GroupId || 
                    reportData.groupId || 
                    "",
            EmpRefNo: reportData.EmpRefNo || 
                     reportData.empRefNo || 
                     "",
            Year: reportData.Year || 
                 reportData.year || 
                 "",
            FromMonth: reportData.FromMonth || 
                      reportData.fromMonth || 
                      "",
            ToMonth: reportData.ToMonth || 
                    reportData.toMonth || 
                    ""
        };
        
         // DEBUG
        
        const response = await axios.post(
            `${API_BASE_URL}/HR/GetSingleEmpSalaryDataForReport`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 11. Get Employee Pay Slip Data (Staff)
export const getEmpPaySlipData = async (reportData) => {
    try {
         // DEBUG
        
        const payload = {
            TransactionRefno: reportData.TransactionRefno || 
                            reportData.transactionRefno || 
                            "",
            EmpRefno: reportData.EmpRefno || 
                     reportData.empRefno || 
                     "",
            CurrentCC: reportData.CurrentCC || 
                      reportData.currentCC || 
                      "",
            CategoryId: reportData.CategoryId || 
                       reportData.categoryId || 
                       "",
            ConslidateTransNo: reportData.ConslidateTransNo || 
                             reportData.conslidateTransNo || 
                             ""
        };
        
         // DEBUG
        
        const response = await axios.post(
            `${API_BASE_URL}/HR/GetEmpPaySlipData`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 12. Get Labour Pay Slip Data
export const getLBPaySlipData = async (reportData) => {
    try {
         // DEBUG
        
        const payload = {
            TransactionRefno: reportData.TransactionRefno || 
                            reportData.transactionRefno || 
                            "",
            LabourId: reportData.LabourId || 
                     reportData.labourId || 
                     "",
            CurrentCC: reportData.CurrentCC || 
                      reportData.currentCC || 
                      "",
            ConslidateTransNo: reportData.ConslidateTransNo || 
                             reportData.conslidateTransNo || 
                             ""
        };
        
         // DEBUG
        
        const response = await axios.post(
            `${API_BASE_URL}/HR/GetLBPaySlipData`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 13. Get Labour Months Salary Report
export const getLBMonthsSalaryForReport = async (reportData) => {
    try {
         // DEBUG
        
        const payload = {
            LabourType: reportData.LabourType || 
                       reportData.labourType || 
                       "",
            CCCode: reportData.CCCode || 
                   reportData.ccCode || 
                   "",
            LabourId: reportData.LabourId || 
                     reportData.labourId || 
                     "",
            GroupId: reportData.GroupId || 
                    reportData.groupId || 
                    "",
            Year: reportData.Year || 
                 reportData.year || 
                 "",
            FromMonth: reportData.FromMonth || 
                      reportData.fromMonth || 
                      "",
            ToMonth: reportData.ToMonth || 
                    reportData.toMonth || 
                    "",
            ContractorCode: reportData.ContractorCode || 
                          reportData.contractorCode || 
                          ""
        };
        
         // DEBUG
        
        const response = await axios.post(
            `${API_BASE_URL}/HR/GetLBMonthsSalaryForReport`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 14. Get Single Labour Salary Data for Report (Details view)
export const getSingleLBSalaryDataForReport = async (reportData) => {
    try {
         // DEBUG
        
        const payload = {
            LabourType: reportData.LabourType || 
                       reportData.labourType || 
                       "",
            CCCode: reportData.CCCode || 
                   reportData.ccCode || 
                   "",
            GroupId: reportData.GroupId || 
                    reportData.groupId || 
                    "",
            LabourId: reportData.LabourId || 
                     reportData.labourId || 
                     "",
            Year: reportData.Year || 
                 reportData.year || 
                 "",
            FromMonth: reportData.FromMonth || 
                      reportData.fromMonth || 
                      "",
            ToMonth: reportData.ToMonth || 
                    reportData.toMonth || 
                    "",
            ContractorCode: reportData.ContractorCode || 
                          reportData.contractorCode || 
                            "NA"
        };
        
         // DEBUG
        
        const response = await axios.post(
            `${API_BASE_URL}/HR/GetSingleLBSalaryDataForReport`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};
// 15. Get Employee Salary Years
export const getEmployeeSalaryYears = async (reportData) => {
    try {
         // DEBUG
        
        // ✅ Determine employee type and set smart defaults
        const employeeType = reportData.EmployeeType || reportData.employeeType || 'Staff';
        const labourType = employeeType === 'Staff' ? 'NA' : (reportData.LabourType || reportData.labourType || '');
        const contractorCode = employeeType === 'Staff' ? 'NA' : (reportData.ContractorCode || reportData.contractorCode || '');
        
        const payload = {
            EmpCategory: reportData.EmpCategory || reportData.empCategory || "",
            CCCode: reportData.CCCode || reportData.ccCode || "",
            GroupId: reportData.GroupId || reportData.groupId || "",
            EmpRefNo: reportData.EmpRefNo || reportData.empRefNo || "",
            LabourType: labourType,
            ContractorCode: contractorCode,
            EmployeeType: employeeType
        };
        
         // DEBUG
        
        const response = await axios.post(
            `${API_BASE_URL}/HR/GetEmployeeSalaryYears`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// ==============================================
// HELPER FUNCTIONS FOR PAYROLL REPORTS
// ==============================================

// Helper function to format Staff Payroll Report Data
export const formatStaffPayrollReportData = (params) => {
    return {
        EmpCategory: params.empCategory || "",
        CCCode: params.ccCode || "",
        GroupId: params.groupId || "",
        EmpRefNo: params.empRefNo || "",
        Year: params.year || "",
        FromMonth: params.fromMonth || "",
        ToMonth: params.toMonth || ""
    };
};

// Helper function to format Labour Payroll Report Data
export const formatLabourPayrollReportData = (params) => {
    return {
        LabourType: params.labourType || "",
        CCCode: params.ccCode || "",
        GroupId: params.groupId || "",
        LabourId: params.labourId || "",
        Year: params.year || "",
        FromMonth: params.fromMonth || "",
        ToMonth: params.toMonth || "",
        ContractorCode: params.contractorCode || ""
    };
};

// Helper function to format Pay Slip Data
export const formatPaySlipData = (params, isLabour = false) => {
    if (isLabour) {
        return {
            TransactionRefno: params.transactionRefno || "",
            LabourId: params.labourId || "",
            CurrentCC: params.currentCC || "",
            ConslidateTransNo: params.conslidateTransNo || ""
        };
    } else {
        return {
            TransactionRefno: params.transactionRefno || "",
            EmpRefno: params.empRefno || "",
            CurrentCC: params.currentCC || "",
            CategoryId: params.categoryId || "",
            ConslidateTransNo: params.conslidateTransNo || ""
        };
    }
};

// Helper function to format filter parameters for GET requests
export const formatPayrollFilterParams = (params) => {
    return {
        category: params.category || "",
        ccCode: params.ccCode || "",
        groupId: params.groupId || "",
        labourType: params.labourType || "",
        contractor: params.contractor || "",
        empType: params.empType || ""
    };
};